import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

const inputClass = "w-full rounded-lg border border-stone-300 bg-[#FAF6F0] p-3 text-sm focus:border-[#B83227] focus:outline-none";
const labelClass = "mb-1.5 block text-xs font-bold uppercase text-stone-700";

export default function SecurityManager() {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) {
      toast.error("La confirmation ne correspond pas au nouveau mot de passe.");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      setForm({ current_password: "", new_password: "", confirm: "" });
      toast.success("Mot de passe modifié. Il sera demandé à la prochaine connexion.");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="security-manager" className="max-w-xl">
      <form onSubmit={submit} className="space-y-4 rounded-xl border border-stone-200 bg-white p-6 shadow-sm">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded bg-[#B83227] text-white">
            <KeyRound className="h-5 w-5" aria-hidden="true" />
          </div>
          <div>
            <h3 className="font-display text-lg font-bold uppercase text-[#1E1B18]">Changer le mot de passe</h3>
            <p className="text-xs text-stone-500">Le nouveau mot de passe est conservé même après redémarrage du site.</p>
          </div>
        </div>
        <div>
          <label className={labelClass}>Mot de passe actuel</label>
          <input data-testid="current-password-input" type="password" className={inputClass} value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} required />
        </div>
        <div>
          <label className={labelClass}>Nouveau mot de passe (8 caractères minimum)</label>
          <input data-testid="new-password-input" type="password" minLength="8" className={inputClass} value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} required />
        </div>
        <div>
          <label className={labelClass}>Confirmer le nouveau mot de passe</label>
          <input data-testid="confirm-password-input" type="password" minLength="8" className={inputClass} value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} required />
        </div>
        <button type="submit" data-testid="change-password-button" disabled={saving} className="rounded bg-[#B83227] px-8 py-3 text-xs font-bold uppercase tracking-wider text-white hover:bg-[#96281E] disabled:opacity-60">
          {saving ? "Enregistrement..." : "Changer le mot de passe"}
        </button>
      </form>
      <p className="mt-4 rounded-xl border border-stone-200 bg-white p-4 text-xs leading-relaxed text-stone-500">
        Astuce : l'adresse e-mail qui reçoit les alertes de nouvelles demandes se règle dans l'onglet « Textes &amp; Images », section Coordonnées &amp; alertes.
      </p>
    </div>
  );
}
